<script>
	// Stores
	import AdminUserSavedFilterStore from '@/Stores/AdminUserSavedFilterStore.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let filter;

	let sending = false;
	let filterName = '';

	$: open && (filterName = '');

	function confirmClicked() {
		if (!filterName) return;

		delete filter.from_date;
		delete filter.to_date;

		sending = true;
		AdminUserSavedFilterStore.saveAdminUserFilter(filter, filterName)
			.then(() => {
				AdminUserSavedFilterStore.getSavedFilters();
				notify({
					type: 'success',
					title: 'Filter Saved',
					message: 'Filter configuration saved.',
					timeout: 3
				});
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Problem with saving filter',
					message: e.error[0] || 'Problem saving filter configuration',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Save Filter Configuration</h2>
		<div class="flex flex-col mt-3 w-full px-4 pt-2 text-center">
			<TextInput
				name="note"
				className="pb-4 w-full"
				bind:value={filterName}
				required={true}
				placeholder="Filter Name"
			/>
			<LoadingButton on:click={confirmClicked} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel </button>
		</div>
	</Modal>
{/if}
